import { sampleImages, sampleItems, sampleItemProgress } from '../sampleData'
import ceil from 'lodash/ceil'
import round from 'lodash/round'

export const getSampleImageFromName = (name, path) => {
  const formattedName = name.replace(/ - /g, ' ').replace(/ /g, '-').toLowerCase()
  const imagesMatch = sampleImages[path].filter(({ name: imageName }) => formattedName.includes(imageName.toLowerCase()))

  if (imagesMatch.length > 0) {
    return imagesMatch[0].src
  } else {
    const randomImage = sampleImages[path][Math.floor(Math.random() * sampleImages[path].length)]

    return randomImage.src
  }
}

export const getAvailableShapesFromFrames = (frames) => {
  let shapes = []

  frames.forEach(({ group }) => {
    if (group) {
      const frameShapes = group.split(',').map(shape => shape.toUpperCase())

      frameShapes.forEach(shape => {
        if (shapes.indexOf(shape) === -1) {
          shapes = [...shapes, shape]
        }
      })
    }
  })

  const emptyShapes = shapes.length === 0
  if (emptyShapes) shapes = ['CUSTOM']

  return shapes
}

export const splitFramesFromShapes = (frames) => {
  let splitFrames = []

  frames.forEach(frame => {
    if (frame.group) {
      const shapes = frame.group.split(',')

      shapes.forEach(shape => {
        splitFrames = [...splitFrames, { ...frame, shape: shape.toUpperCase() }]
      })
    } else {
      splitFrames = [...splitFrames, { ...frame, shape: 'CUSTOM' }]
    }
  })

  return splitFrames
}

export const separateLogics = (logics) => {
  let shapeLogics = []
  let attributeLogics = []
  let sizeLogics = []

  logics.forEach(([logicName, ...logic]) => {
    switch (logicName) {
      case 'shape': {
        shapeLogics = [...shapeLogics, [logicName, ...logic]]
        break
      }
      case 'size': {
        sizeLogics = [...sizeLogics, [logicName, ...logic]]
        break
      }
      default:
        attributeLogics = [...attributeLogics, [logicName, ...logic]]
    }
  })

  return { shapeLogics, attributeLogics, sizeLogics }
}

export const getSampleOrderItems = () => sampleItems
export const getSampleProductionProgress = (itemId) => {
  const data = sampleItemProgress

  return data[`id-${itemId}`]
}

export const isProductWithLongSizeLabel = (product) => {
  const productsWithLongSize = ['matted-prints', 'torn-edge-matted-prints', 'weighted-matted-prints']

  return productsWithLongSize.indexOf(product) !== -1
}

export const needCroppingFunc = (croppedArea, original, croppedAreaAspect) => {
  const currentWidth = ceil(original.props.image_sizes[0] * ((croppedArea?.width || 100) / 100), 3)
  const currentHeight = ceil(original.props.image_sizes[1] * ((croppedArea?.height || 100) / 100), 3)
  const isFlippedRatio = croppedArea?.isFlippedRatio || false
  const expectedRatio = round(isFlippedRatio ? 1 / croppedAreaAspect : croppedAreaAspect, 2)
  const currentRatio = round(currentWidth / currentHeight, 2)
  return expectedRatio !== currentRatio
}
